import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation UpdateActivityNotification($id: ID!, $model: ActivityNotificationInput!) {
  updateActivityNotification(id: $id, activityNotification: $model){
    id
    name
    event
    text
    active
    channels {
      id
      name
    }
    requestTypePriorities {
      id
      requestType{
        id
        name
      }
      channel {
        id
        name
      }
    }
  }
}`;

const fieldsName = {
  name: 'T_ACTIVITY_NOTIFICATION_MESSAGE',
  event: 'T_EVENT',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function updateActivityNotification(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateActivityNotification)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default updateActivityNotification;
